module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-count"
  }, [_c('div', {
    staticClass: "site-count__circle"
  }, [_c('span', {
    staticClass: "site-count__number font-primary--bold"
  }, [_vm._v(_vm._s(_vm.count))])]), _vm._v(" "), _c('span', {
    staticClass: "site-count__supporting-text"
  }, [_vm._v("Washrooms")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc81f88a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/WashroomCountSingle/WashroomCountSingle.vue
// module id = 568
// module chunks = 1